export default __webpack_public_path__ + "static/media/Pet Yellow Lotus.77e9fef2.jpg";